import { SunriseSunset } from './SunriseSunset';
import { getMonth } from 'date-fns';

const sunInfoForTheNetherlands: Record<number, SunriseSunset> = {
  1: { sunriseHour: 10, sunsetHour: 16 },
  2: { sunriseHour: 9, sunsetHour: 16 },
  3: { sunriseHour: 8, sunsetHour: 17 },
  4: { sunriseHour: 8, sunsetHour: 19 },
  5: { sunriseHour: 5, sunsetHour: 20 },
  6: { sunriseHour: 6, sunsetHour: 21 },
  7: { sunriseHour: 6, sunsetHour: 21 },
  8: { sunriseHour: 7, sunsetHour: 21 },
  9: { sunriseHour: 8, sunsetHour: 19 },
  10: { sunriseHour: 9, sunsetHour: 18 },
  11: { sunriseHour: 9, sunsetHour: 16 },
  12: { sunriseHour: 10, sunsetHour: 17 },
};

export function getSunriseSunset(date: Date): SunriseSunset {
  // JS month number is zero-indexed, so add 1 for 'normal' look-up
  const monthNumber: number = getMonth(date) + 1;
  return sunInfoForTheNetherlands[monthNumber];
}
